import type { UserRole } from '../../../entities/user';

export interface UserForm {
  name: string;
  email: string;
  phone: string;
  password: string;
  role: UserRole;
}

export const ROLE_OPTIONS: { value: UserRole; label: string }[] = [
  { value: 'ADMIN', label: 'Администратор' },
  { value: 'MANAGER', label: 'Тимлид' },
  { value: 'USER', label: 'Менеджер' },
];

export const generatePassword = (length = 12): string => {
  const upper = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
  const lower = 'abcdefghjkmnpqrstuvwxyz';
  const digits = '23456789';
  const special = '!@#$%&*';
  const all = upper + lower + digits + special;
  const rand = () => crypto.getRandomValues(new Uint32Array(1))[0];
  let pwd =
    upper[rand() % upper.length] +
    lower[rand() % lower.length] +
    digits[rand() % digits.length] +
    special[rand() % special.length];
  for (let i = 4; i < length; i++) pwd += all[rand() % all.length];
  return pwd
    .split('')
    .sort(() => (rand() % 2 ? 1 : -1))
    .join('');
};

export const EMPTY_USER_FORM: UserForm = { name: '', email: '', phone: '', password: '', role: 'USER' };
